import React, { useMemo, useState } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Image, Transformation } from 'cloudinary-react'
import PropTypes from 'prop-types'
import { CLOUDINARY_NAME } from '../../../../containers/CreateACard'

const useStyles = makeStyles((theme) => ({
    item: {
        cursor: 'pointer',
        overflow: 'hidden',
        lineHeight: '0',
        borderRadius: '4px',
    },
    active: {
        borderRadius: '10px',
        border: '3px solid #592163',
    },
    image: {
        width: '100%',
        height: '100%',
        aspectRatio: '180 / 114',
        objectFit: 'cover',
    },
    designsContainer: {
        position: 'relative',
    },
    badgeGeneralStyles: {
        position: 'absolute',
        background: 'white',
        borderRadius: '4px',
        border: '1px solid #592063',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        textAlign: 'center',
        lineHeight: '14px',
        color: '#592063',
        width: '103px',
        fontSize: '12px',
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        marginTop: '-18px',
        height: '21px',
        [theme.breakpoints.up('sm')]: {
            height: '27px',
            width: '130px',
            fontSize: '16px',
        },
    },
    topRated: {
        top: '10px',
    },
    mostPurchased: {
        top: '10px',
    },
}))

const BacCardDesign = ({
    item,
    cloudinaryId,
    imageUrl,
    imageTitle,
    imageAlt,
    selectedItem,
    onItemSelected,
    overlay,
}) => {
    const classes = useStyles()
    const [loading, setLoading] = useState(true)
    const isSelected = useMemo(() => {
        return selectedItem && item.id === selectedItem.id
    }, [selectedItem, item.id])
    // Handler to trigger when image finishes loading
    const handleImageLoad = () => {
        setLoading(false)
    }
    return (
        <div className={classes.designsContainer}>
            {item.is_top_rated && (
                <div
                    className={`${classes.badgeGeneralStyles} ${classes.topRated}`}
                >
                    Top rated
                </div>
            )}
            {!item.is_top_rated && item.is_most_purchased && (
                <div
                    className={`${classes.badgeGeneralStyles} ${classes.mostPurchased}`}
                >
                    Most purchased
                </div>
            )}
            {!item.is_top_rated &&
                !item.is_most_purchased &&
                item.is_staff_selected && (
                    <div
                        className={`${classes.badgeGeneralStyles} ${classes.mostPurchased}`}
                    >
                        Staff selected
                    </div>
                )}

            {cloudinaryId ? (
                <div
                    className={`${classes.item} ${
                        isSelected ? classes.active : ''
                    }`}
                >
                    <Image
                        data-testid="card-design-image"
                        cloudName={CLOUDINARY_NAME}
                        publicId={cloudinaryId}
                        loading="lazy"
                        className={classes.image}
                        width="180"
                        height="114"
                        responsive
                        onLoad={handleImageLoad}
                        style={
                            loading
                                ? { visibility: 'hidden' }
                                : { visibility: 'visible' }
                        }
                        title={imageTitle}
                        alt={imageAlt}
                        onClick={() => {
                            onItemSelected(item)
                        }}
                    >
                        {/* Add fake emboss with prebuilt transformation */}
                        {overlay}
                        <Transformation
                            width="236"
                            crop="scale"
                            fetchFormat="auto"
                            quality="auto"
                        />
                    </Image>
                </div>
            ) : (
                <div
                    className={`${classes.item} ${
                        isSelected ? classes.active : ''
                    }`}
                >
                    <img
                        data-testid="card-design-image"
                        className={classes.image}
                        src={imageUrl}
                        title={imageTitle}
                        alt={imageAlt}
                        onClick={() => {
                            onItemSelected(item)
                        }}
                        width="137"
                        height="89"
                        loading="lazy"
                    />
                </div>
            )}
        </div>
    )
}

export default BacCardDesign

BacCardDesign.propTypes = {
    cloudinaryId: PropTypes.string,
    imageAlt: PropTypes.string,
    imageTitle: PropTypes.string,
    imageUrl: PropTypes.string,
    item: PropTypes.object,
    onItemSelected: PropTypes.func,
    selectedItem: PropTypes.object,
    overlay: PropTypes.element,
}
